import { JiraExportResponse } from '../models/JiraExportResponse';
import { JiraError } from '../models/valueObjects/JiraError';
import { JiraErrorDetail } from '../models/valueObjects/JiraErrorDetail';
import { JiraIssue } from '../models/valueObjects/JiraIssue';

export class JiraIssueResponseMapper {
  mapGQLModel(data: any): JiraExportResponse {
    const issues = data?.issues?.map((i: any) => new JiraIssue(i.issueUrl)) ?? [];
    if (!data.errors || data.errors.length === 0) {
      return new JiraExportResponse(issues, [], false);
    }

    // TODO(CGFT-1272): Change "errors" to "errorDetails" after FF removal
    const errors = data.errors.map((e: any) => {
      const details = e.errorDetails.map((d: any) => new JiraErrorDetail(d.error, d.field, d.value));
      return new JiraError(details);
    });
    return new JiraExportResponse(issues, errors, false);
  }
}
